import LocationPageTemplate from '@/components/locations/LocationPageTemplate';

const OjaiPage = () => (
  <LocationPageTemplate
    city="Ojai"
    path="/ojai"
    postalCode="93023"
    latitude={34.448}
    longitude={-119.2429}
    metaTitle="Pressure Washing & Cleaning Services in Ojai, CA | Ventura Power Washing"
    metaDescription="Hot-water pressure washing, soft wash, window, gutter, and solar panel cleaning in Ojai, CA. Eco-safe detergents, insured, no long-term contracts. Call (805) 464-7166."
    keywords="pressure washing Ojai, power washing Ojai CA, soft wash Ojai, window cleaning Ojai, gutter cleaning Ojai, exterior cleaning 93023"
    schemaDescription="Pressure washing, soft wash, window, gutter, solar panel, and carpet cleaning in Ojai, CA."
    heroText="Hot-water pressure washing and gentle soft washing for Ojai Valley homes and properties, using biodegradable, plant-safe detergents. Insured, locally owned, and no long-term contracts."
    localHeading="What Makes Ojai Properties Unique to Clean?"
    localText="Ojai is an inland valley community with a dry climate, mature oaks and sycamores, and a mix of stucco, adobe-style, and ranch-style homes. Dust and leaf litter build up quickly on driveways, roofs, and gutters, and many properties have gardens we take extra care to protect. We clean homes and commercial properties throughout the Ojai Valley."
    neighborhoods={[]}
    localFactors={[
      'Oak and sycamore leaf litter fills gutters and collects on roofs and patios.',
      'Dry inland dust settles on windows, solar panels, and driveways.',
      'Gardens and mature plantings are pre-soaked and protected on every job, with runoff controlled.',
    ]}
    faqs={[
      {
        question: 'Do you serve Ojai?',
        answer: 'Yes. We serve homeowners and businesses throughout Ojai and the surrounding Ojai Valley.',
      },
      {
        question: 'How much does pressure washing cost in Ojai, CA?',
        answer: 'Most driveway, patio, and walkway pressure washing jobs in Ojai run $150-$400, depending on square footage and surface type. We provide a free estimate before any work begins.',
      },
      {
        question: 'Are your cleaning products safe for Ojai gardens and pets?',
        answer: 'We use 100% biodegradable, plant-safe, pet-safe detergents. We pre-soak landscaping, control runoff, and apply neutralizers when needed.',
      },
      {
        question: 'How often should gutters be cleaned in Ojai?',
        answer: 'Homes near mature oaks and sycamores often need gutter cleaning at least once a year, ideally before the rainy season.',
      },
    ]}
  />
);

export default OjaiPage;
